import type { EntityDescriptor } from "../config/types";

type Builder = (x: number, y: number) => EntityDescriptor[];

const at = (type: string, x: number, y: number, variant?: string): EntityDescriptor => ({ type, x, y, variant });

function wallWithGap(type: string, centreX: number, y: number, gapHalf: number, halfSpan: number, step: number) {
    const pieces: EntityDescriptor[] = [];
    for (let offset = gapHalf; offset <= halfSpan; offset += step) {
        pieces.push(at(type, centreX - offset, y), at(type, centreX + offset, y));
    }
    return pieces;
}

export const SET_PIECES: Record<string, Builder> = {
    jump_line: (x, y) => [at("kicker", x, y - 10), at("tabletop", x, y + 6)],
    tree_wall_gap: (x, y) => wallWithGap("pine_large", x, y, 3, 18, 2.5),
    fence_gap: (x, y) => wallWithGap("fence", x, y, 3, 16, 2),
    log_line: (x, y) => [at("log", x - 3, y - 12), at("log", x + 3, y), at("log", x - 2, y + 12)],
    berm_series: (x, y) => [at("berm", x - 2, y - 12, "left"), at("berm", x + 2, y + 4, "right")],
    chairlift: (x, y) => [
        at("lift_pylon", x + 12, y - 20),
        at("lift_pylon", x + 12, y + 20),
        at("lift_chair", x + 12, y - 6, "two_riders"),
        at("lift_chair", x + 12, y + 8, "empty"),
    ],
    rock_garden: (x, y) => [at("rock_garden", x, y), at("rock_small", x - 6, y + 3), at("rock_small", x + 6, y - 4)],
};

export function buildSetPiece(name: string, x: number, y: number): EntityDescriptor[] {
    return SET_PIECES[name]?.(x, y) ?? [];
}
